import { render, staticRenderFns } from "./VisitorNavbar.vue?vue&type=template&id=2838a622&scoped=true&"
import script from "./VisitorNavbar.vue?vue&type=script&lang=js&"
export * from "./VisitorNavbar.vue?vue&type=script&lang=js&"
import style0 from "./VisitorNavbar.vue?vue&type=style&index=0&id=2838a622&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2838a622",
  null
  
)

export default component.exports